import React from 'react';
import { Heading } from '../../components/guide/Heading';
import HeroBanner from "../../components/guide/HeroBanner";
import BannerImg from "../../assets/images/banner/guide_banner_4.png";
import CtaBanner from "../../components/guide/CtaBanner";
import HeaderPath from "../../components/common/HeaderPath";

const ProductGuidePage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 광고 상품 가이드'}/>
            <HeroBanner image={BannerImg} message="미분양 브랜딩부터, 현장 완판까지!"/>
            <Heading className="hidden lg:block lg:mt-[93px] lg:mb-[96px]" as="h1" size="h1">
                광고 상품 가이드
            </Heading>
            <div className="mt-0 flex flex-col gap-12 sm:gap-16 lg:mt-0 lg:gap-[93px]">

               <div>
                   <h2 className="mb-5 text-[20px] font-[700] text-black sm:mb-[19px] sm:text-[25px]">
                       #코어타겟프리미엄  #하이타겟2.0
                   </h2>
                   <Heading as="p" size="subtitle" className="text-black font-[400] leading-relaxed">
                       분양의신은 부동산 광고 현장에 최적화된 두 가지 상품 라인업을 보유하고 있습니다.
                       단순히 송출에 그치지 않고, 성과를 중심으로 설계된 상품 구조를 통해 고객이 원하는 성과(콜 전환 / 브랜딩)를 달성할 수 있도록 돕습니다.
                   </Heading>
               </div>

                <div>
                    <h2 className="mb-5 text-[20px] font-[700] text-black sm:mb-[19px] sm:text-[25px]">
                        상품별 특징 비교
                    </h2>
                    <Heading as="p" size="subtitle" className="text-black font-[400] leading-relaxed">
                        즉시 성과가 필요한 고객에게는 코어타겟 프리미엄을, 장기적인 인지도와 신뢰 구축이 필요한 고객에게는 하이타겟 2.0을 추천합니다.
                    </Heading>
                    <div
                        className="mt-5"
                        style={{
                            fontFamily:
                                "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Noto Sans, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
                        }}
                    >
                        <div className="overflow-x-auto">
                            <table
                                className="w-full border-collapse text-center text-sm font-normal leading-tight tracking-[0] sm:text-[16px]">
                                <thead>
                                <tr>
                                    <th className="text-left border border-[#E0E4E8] bg-[#343A40] px-[12px] py-[10px] text-white">구분</th>
                                    <th className="border border-[#E0E4E8] bg-[#343A40] px-[12px] py-[10px] text-white">
                                        <div className={'flex justify-center gap-1 items-center'}>
                                       <div className={'w-[5px] h-[5px] bg-[#0169EB]'}/> 코어타겟 프리미엄
                                        </div>
                                    </th>
                                    <th className="border border-[#E0E4E8] bg-[#343A40] px-[12px] py-[10px] text-white">
                                        <div className={'flex justify-center gap-1 items-center'}>
                                            <div className={'w-[5px] h-[5px] bg-[#FDE7BB]'}/>하이타겟 2.0
                                            </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>주요 목적</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">즉시 전환(콜·상담 확보)</td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">브랜드 친숙도·신뢰 구축</td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>광고 콘텐츠</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">
                                        전환형 배너 13종, 퍼포먼스 모바일 홈페이지, 템플릿형 PC 홈페이지
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">
                                        몰입형 배너·영상 포함 배너 47종, 브랜딩 PC 홈페이지, 퍼포먼스 모바일 홈페이지
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>최적화 방식</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">실시간 성과 데이터 기반 최적화</td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">반복 노출·도달 기반 장기 최적화</td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>성과 지표</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">클릭수, 전환수(콜) 중심</td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">도달수, 순 사용자수 중심</td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>적합 현장</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">단기 성과 필요 현장, 미분양 현장</td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">조건변경 현장, 브랜드 인지도 낮은 현장
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="whitespace-nowrap text-left border border-[#E0E4E8] px-[12px] py-[10px] bg-[#F1F3F5]">
                                        <span className={'font-[600]'}>광고 운영 특징</span>
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">광고 예산을 “지금 상담할 수 있는 고객”에게
                                        집중
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-[12px] py-[10px] text-left">고객이 브랜드에 익숙해질 때까지 다양한 배너로
                                        반복 접촉
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>


                <CtaBanner
                    message="우리 현장에 맞는 상품이 궁금하신가요?"
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default ProductGuidePage;
